/**
 * Wave 3 · 23 #9 — "Chase supplier" state of a late LPO (pure functions).
 *  - never chased            → { state: 'none' }
 *  - chased, no new date yet → { state: 'asked', text: 'ETA asked 2 d ago · no reply' }
 *  - new date recorded       → { state: 'revised', text: 'New ETA 15 Oct', sub: 'was 12 Mar' }
 */
import { ageDays, formatDate } from '@/lib/format';

const text = (value) => String(value ?? '').trim();

export function chaseState(info, { now } = {}) {
  const lastChase = text(info?.last_chase_at);
  const revisedAt = text(info?.eta_revised_at);
  const original = text(info?.original_expected_date);
  const expected = text(info?.expected_start_delivery_date ?? info?.expected);
  const count = Number(info?.chase_count ?? (Array.isArray(info?.chases) ? info.chases.length : 0)) || 0;
  if (revisedAt && (!lastChase || revisedAt >= lastChase)) {
    return {
      state: 'revised',
      text: `New ETA ${formatDate(expected, { year: 'auto', now })}`,
      sub: original ? `was ${formatDate(original, { year: 'auto', now })}` : '',
      count,
    };
  }
  if (lastChase) {
    const days = ageDays(lastChase, { now });
    const when = days === null ? '' : days <= 0 ? 'today' : days === 1 ? 'yesterday' : `${days} d ago`;
    return { state: 'asked', text: `ETA asked ${when}`.trim(), sub: 'no reply', count, days };
  }
  return { state: 'none', count };
}

/** wa.me link with the message (no number: WhatsApp asks whom to send it to). */
export const whatsappHref = (body) => `https://wa.me/?text=${encodeURIComponent(String(body || ''))}`;

/** mailto: link for "Open in mail app". */
export function mailtoHref({ to = '', subject = '', body = '' }) {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  const recipients = String(to || '').split(/[\s,;]+/).filter(Boolean).join(',');
  return `mailto:${recipients}${params.length ? `?${params.join('&')}` : ''}`;
}
